import queryString from 'query-string';
import { BUNDLE_ID_LIST, getQuery, MEDIA_SOURCE } from '../const';
import { getSource } from './setSource';

/**
 * 为url添加参数，如果addonParams存在和后端下发的参数重合，以后端为准
 * 如果addonParams里面存在blacklist里的参数，会被过滤
 * @param url 需要添加参数的url
 * @param addonParams 需要添加的参数
 * @param blacklist 需要过滤的参数, 如果有这些参数，一定是后端拼
 */
export const modifyUrlWithParams = (url: string, addonParams: { [key: string]: any } = {}, blacklist: string[] = []) => {
    try {
        const parseUrl = queryString.parseUrl(url);
        const originQuery = { ...(parseUrl.query || {}) };
        const addonParamsKeys = Object.keys(addonParams);

        addonParamsKeys.forEach(key => {
            if (blacklist.includes(key) || originQuery.hasOwnProperty(key)) {
                return;
            }

            originQuery[key] = addonParams[key];
        });

        return queryString.stringifyUrl(
            {
                url: parseUrl.url,
                query: originQuery,
            },
            {
                skipNull: true,
                skipEmptyString: true,
            }
        );
    } catch (error) {
        return url;
    }
};

export function removeEmptyFields(obj) {
    // 创建一个新的对象用于存储非空字段
    const newObj = {};

    // 遍历对象的所有字段
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            // 检查字段是否为空
            if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
                // 如果字段不为空，将其添加到新对象中
                newObj[key] = obj[key];
            }
        }
    }

    return newObj;
}

export function addSourceToURL(originUrl: string) {
    const bundleId = getQuery('bundleId');

    // 大卡不改变 Source 参数
    if (bundleId === BUNDLE_ID_LIST.EcommCommerce) {
        return queryString.stringifyUrl({
            url: originUrl,
            query: {
                sourceBundle: getQuery('bundleId'),
                urlVersion: 2,
            },
        });
    }

    return queryString.stringifyUrl({
        url: originUrl,
        query: {
            source: getSource(),
            sourceBundle: getQuery('bundleId'),
            urlVersion: 2,
        },
    });
}

export function addExtParamsToURL(originUrl: string) {
    const urlParsed = queryString.parseUrl(originUrl);
    const extParamsMode = urlParsed.query.extParamsMode || '';
    if (extParamsMode === 'extend') {
        urlParsed.query.extParams = getQuery('extParams') || '';
    }

    return queryString.stringifyUrl(urlParsed);
}

// 将 MediaSource 添加到整体的 URL 上
export function modifyExtParamsToUrl(originUrl: string) {
    const urlParsed = queryString.parseUrl(originUrl);
    const extParamsStr = urlParsed.query.extParams || '{}';
    try {
        const extParamsObj = JSON.parse(decodeURIComponent(Array.isArray(extParamsStr) ? extParamsStr[0] : extParamsStr));
        extParamsObj.cT = MEDIA_SOURCE;
        urlParsed.query.extParams = encodeURIComponent(JSON.stringify(extParamsObj));
        return queryString.stringifyUrl(urlParsed);
    } catch (e) {
        return originUrl;
    }
}
